// Collection filter positioning - works with language switching
function moveCollectionFilters() {
  const headerTitle = document.querySelector(".collection__header h2");
  
  // Keep header hidden initially
  if (headerTitle) {
    headerTitle.classList.remove('filters-positioned');
  }
  
  setTimeout(function() {
    const cloudSearchFilters = document.querySelector("#cloud_search_filters_root");
    const collectionBanner = document.querySelector(".collection-banner");

    if (cloudSearchFilters && collectionBanner) {
      if (!collectionBanner.contains(cloudSearchFilters)) {
        collectionBanner.appendChild(cloudSearchFilters);
      }
      
      cloudSearchFilters.style.opacity = "1";
      
      // Set up scroll handler
      if (!collectionBanner.parentElement.hasAttribute('data-scroll-handler-added')) {
        // ... scroll handler code ...
        collectionBanner.parentElement.setAttribute('data-scroll-handler-added', 'true');
      }
      
      // ONLY show header after everything is positioned
      if (headerTitle) {
        headerTitle.classList.add('filters-positioned');
      }
    } else {
      // Fallback - show header anyway
      if (headerTitle) {
        headerTitle.classList.add('filters-positioned');
      }
    }
  }, 1000);
}

// Collection filter positioning for filtered pages - works with language switching
function moveAndLockFilters() {
  // Only execute if URL contains "filter_"
  if (!window.location.href.includes("filter_")) {
    return;
  }
  
  // Immediately hide the collection banner AND header to prevent layout shifting
  const initialBanner = document.querySelector(".collection-banner");
  const headerTitle = document.querySelector(".collection__header h2");
  
  if (initialBanner) {
    initialBanner.style.visibility = "hidden";
    initialBanner.style.opacity = "0";
  }
  
  if (headerTitle) {
    headerTitle.style.opacity = "0";
  }
  
  // Function to move filters and ensure they stay there
  function moveAndLockFiltersInner() {
  console.log("Moving and locking filters");
  const cloudSearchFilters = document.querySelector("#cloud_search_filters_root");
  const collectionBanner = document.querySelector(".collection-banner");
  
  if (cloudSearchFilters && collectionBanner) {
    // Move the element
    collectionBanner.appendChild(cloudSearchFilters);
    
    // Apply styles to filters
    cloudSearchFilters.style.cssText = "opacity: 1 !important; visibility: visible !important;";
    
    // Make the collection banner visible
    collectionBanner.style.transition = "opacity 0.3s ease";
    collectionBanner.style.visibility = "visible";
    collectionBanner.style.opacity = "1";
    
    // Set up scroll handler and mutation observer...
    // ... (your existing code) ...
    
    // ONLY show header at the very end after all positioning is complete
    setTimeout(function() {
      const currentHeaderTitle = document.querySelector(".collection__header h2");
      if (currentHeaderTitle) {
        currentHeaderTitle.classList.add('filters-positioned');
      }
    }, 100); // Small delay to ensure layout is settled
    
    return true;
  }
  return false;
}
  
  // Wait for everything else to load, then run our script
  setTimeout(function() {
    let success = moveAndLockFiltersInner();
    
    // If unsuccessful, try again after a longer delay
    if (!success) {
      setTimeout(function() {
        success = moveAndLockFiltersInner();
        
        // Last attempt - if still not working, show the banner and header anyway to avoid hiding content
        if (!success) {
          setTimeout(function() {
            const banner = document.querySelector(".collection-banner");
            const fallbackHeaderTitle = document.querySelector(".collection__header h2");
            
            if (banner) {
              banner.style.visibility = "visible";
              banner.style.opacity = "1";
              console.log("Showing banner anyway as fallback");
            }
            
            if (fallbackHeaderTitle) {
              fallbackHeaderTitle.classList.add('filters-positioned');
              console.log("Showing header anyway as fallback");
            }
          }, 2000);
        }
      }, 1500);
    }
  }, 1000);
}

// Main initialization function
function initCollectionFilters() {
  // Run the appropriate function based on URL
  if (window.location.href.includes("filter_")) {
    moveAndLockFilters();
  } else {
    moveCollectionFilters();
  }
}

// Event listeners for different page load scenarios
document.addEventListener("DOMContentLoaded", initCollectionFilters);

// Listen for Shopify's theme events (if available)
if (typeof Shopify !== 'undefined' && Shopify.theme) {
  document.addEventListener('shopify:section:load', initCollectionFilters);
  document.addEventListener('shopify:section:reorder', initCollectionFilters);
}

// Listen for history API changes (back/forward buttons, language switching)
window.addEventListener('popstate', function() {
  setTimeout(initCollectionFilters, 500);
});

// Listen for URL changes (for AJAX navigation)
let currentUrl = window.location.href;
const urlObserver = new MutationObserver(function() {
  if (window.location.href !== currentUrl) {
    currentUrl = window.location.href;
    console.log('URL changed, reinitializing filters');
    setTimeout(initCollectionFilters, 500);
  }
});

// Start observing for URL changes
urlObserver.observe(document.querySelector('title'), {
  childList: true,
  subtree: true
});

// Also listen for window focus (when user comes back to tab after language switch)
window.addEventListener('focus', function() {
  setTimeout(function() {
    // Check if we need to reinitialize
    const cloudSearchFilters = document.querySelector("#cloud_search_filters_root");
    const collectionBanner = document.querySelector(".collection-banner");
    
    if (cloudSearchFilters && collectionBanner && !collectionBanner.contains(cloudSearchFilters)) {
      console.log('Reinitializing filters on window focus');
      initCollectionFilters();
    }
  }, 300);
});

const filterCheckInterval = setInterval(function() {
  const cloudSearchFilters = document.querySelector("#cloud_search_filters_root");
  const collectionBanner = document.querySelector(".collection-banner");
  
  if (cloudSearchFilters && collectionBanner) {
    // Check if filters are hidden and should be visible
    if (cloudSearchFilters.style.opacity === "0" || cloudSearchFilters.style.opacity === "") {
      if (!collectionBanner.contains(cloudSearchFilters)) {
        console.log('Periodic check: repositioning filters');
        initCollectionFilters();
        
        // Clear the interval after repositioning
        clearInterval(filterCheckInterval);
        console.log('Filter check interval cleared - task completed');
      }
    }
  }
}, 3000);




// 22.08.23 - markus
// reduce product description mobile
jQuery(document).ready(function () {

    
    
    // IF PRODUCT DETAIL PAGE
    if (jQuery('.template-product .product__description')[0]) {

        // DEVICE
        var isMobile = navigator.userAgent.match(/(iPhone|iPod|iPad|Android|webOS|BlackBerry|IEMobile|Opera Mini)/i);
        if (isMobile) {

            // IF TEXT TO LONG, reduce text and show button
            if (jQuery('.product__description.rte').text().length > 130) {

                var descOriginHtml = jQuery('.product__description.rte').html();
                var descText = jQuery('.product__description.rte').text().substr(0, 130) + '...';
                jQuery('.product__description.rte').text(descText);

                jQuery('a.custom-mobile-click-more-desc').addClass('show');
            }
        }

        // CLICK MORE BUTTON, hide button and restore origin desc
        jQuery('a.custom-mobile-click-more-desc').click(function (e) {
            e.preventDefault();

            jQuery('a.custom-mobile-click-more-desc').removeClass('show');
            jQuery('.product__description.rte').html(descOriginHtml);
        });
    }
    

});

// [CK-MIT] Chat Translation 
// [CK-MIT] Chat Translation 
document.addEventListener("DOMContentLoaded", function() {
  let mitStoreLanguage = document.querySelector('html').getAttribute('lang');
  
  if (mitStoreLanguage === 'en') {
    
    function waitForElm(selector) {
      return new Promise(resolve => {
          if (document.querySelector(selector)) {
              return resolve(document.querySelector(selector));
          }
  
          const observer = new MutationObserver(mutations => {
              if (document.querySelector(selector)) {
                  resolve(document.querySelector(selector));
                  observer.disconnect();
              }
          });
  
          observer.observe(document.body, {
              childList: true,
              subtree: true
          });
      });
    }

    // First wait for the inbox-online-store-chat element
    waitForElm('inbox-online-store-chat').then((elm) => {
      // Then wait for the ShopifyChat element to be available
      function waitForShopifyChat() {
        return new Promise(resolve => {
          const checkForShopifyChat = () => {
            const shopifyChat = document.getElementById('ShopifyChat');
            if (shopifyChat) {
              console.log("ShopifyChat found:", shopifyChat);
              resolve(shopifyChat);
            } else {
              console.log("ShopifyChat not found yet, retrying...");
              setTimeout(checkForShopifyChat, 500);
            }
          };
          checkForShopifyChat();
        });
      }

      // Wait for ShopifyChat and then proceed with the translation
      waitForShopifyChat().then(shopifyChat => {
        // Wait a bit to ensure the shadow DOM is fully initialized
        setTimeout(() => {
          const shadowRoot = shopifyChat.shadowRoot;
          
          if (!shadowRoot) {
            console.error("ShopifyChat shadow root is not available yet");
            return;
          }
        
          function chatTranslate() {
            const storeInfo = shadowRoot.querySelector('.store-info p');
            
            const buttonElements = shadowRoot.querySelectorAll('.instant-answers-list__prompt');          
            const firstButtonElement = buttonElements[0];
            const secondButtonElement = buttonElements[1];
            const thirdButtonElement = buttonElements[2];
            const forthButtonElement = buttonElements[3];
            const fifthButtonElement = buttonElements[4];

            // Beispiel: Ändern des Textinhalts des <p>-Elements
            if (storeInfo) {
              storeInfo.textContent = 'Hello! 👋 We are here to help you! Customer service: MON - FRI, 8 AM - 12 PM and 1 PM - 4 PM. We usually respond within 5-10 minutes.';
            } 

            if (firstButtonElement) {
              firstButtonElement.textContent = 'Shipping status of my order?';
            }
        
            if (secondButtonElement) {
              secondButtonElement.textContent = "How do I return from Austria?";
            }
        
            if (thirdButtonElement) {
              thirdButtonElement.textContent = "How do I return from Germany?";
            }

            if (forthButtonElement) {
              forthButtonElement.textContent = "Which countries do we ship?";
            }      

            if (fifthButtonElement) {
              fifthButtonElement.textContent = "In which unit are the sizes indicated?";
            }  

            // Answers
            shadowRoot.querySelectorAll('.message-bubble-outgoing span').forEach(function(element) {
              if (element.textContent.includes("Sendungsverlauf meiner Bestellung")) {
                element.outerHTML = "<span>Shipping status of my order?</span>";
              }
              if (element.textContent.includes("Österreich?")) {
                element.outerHTML = "<span>How do I return from Austria?</span>";
              }      
              if (element.textContent.includes("Deutschland?")) {
                element.outerHTML = "<span>How do I return from Germany?</span>";
              }      
              if (element.textContent.includes("In welche Länder")) {
                element.outerHTML = "<span>Which countries do we ship?</span>";
              }      
              if (element.textContent.includes("Größen werden")) {
                console.log(element)
                element.outerHTML = "<span>In which unit are the sizes indicated?</span>";
              }                      
            });

            shadowRoot.querySelectorAll('.message-bubble-incoming span').forEach(function(element) {
              if (element.textContent.includes("Hallo, bitte geben Sie uns Ihre Bestellnummer, ")) {
                element.outerHTML = "<span>Hello, please provide your order number starting with #XXXXX-D1948. We'll help you check your package status.</span>";
              }
              if (element.textContent.includes("Österreich ")) {
                element.outerHTML = "<span>Orders from Austria include a prepaid return label. Please register your return in your customer account. Returns are free of charge. Your Dantendorfer Team 💙</span>";
              }      
              if (element.textContent.includes("LogoIX")) {
                element.outerHTML = "<span>To start your return, log into your customer account. You received the LogoIX return label in your shipping confirmation email. If you can't find the email, just give us your order number (#XXXXX-D1948), and we'll send you another copy by email. Your Dantendorfer Team. 💙</span>";
              }    
              if (element.textContent.includes("4-6 Werktage")) {
                element.outerHTML = "<span>We ship worldwide. Once we confirm availability of your items, you'll receive your package in 4-6 business days. Customers are responsible for return shipping costs. Your Dantendorfer Team 💙</span>";
              }      
              if (element.textContent.includes("internationalen Hersteller")) {
                element.outerHTML = "<span>Hello, we have converted all our international manufacturers' sizes into German clothing sizes. If you're unsure which size corresponds to your country, please check the size chart provided with each product. Best regards, Your Dantendorfer Team</span>";
              }    
              if (element.textContent.includes("+43 662 845735 180")) {
                element.outerHTML = "<span>Thank you for your message! We will get back to you as soon as possible!<br><br>For urgent matters, you can also reach us by phone during our business hours at +43 662 845735 180.<br><br>Best regards from Salzburg, your Dantendorfer team. 💙</span>";
              }
              if (element.textContent.includes("nicht online")) {
                element.outerHTML = "<span>Hello, we are currently not online. Please provide us with any information that will make it easier for us to assist you.<br><br>We will get back to you as soon as possible.<br><br>Customer service hours: Monday - Friday, 8am - 12pm | 1pm - 4pm.<br><br>Best regards from Salzburg, your Dantendorfer team. 💙</span>";
              }
            });    
          }

          // Run function when clicking on chat
          setInterval(function(){
            chatTranslate();
          }, 500);     

          // Set interval so that chat is translated within the first seconds
          let chatMaxIterations = 10; // Increased iterations for better reliability
          let chatCurrentIteration = 0;
          
          // Start the interval
          let chatInterval = setInterval(function() {
            chatTranslate();
            chatCurrentIteration++;

            if (chatCurrentIteration >= chatMaxIterations) {
              clearInterval(chatInterval);
            }
          }, 500);
        }, 1000); // Wait 1 second to ensure shadow DOM is fully initialized
      }).catch(error => {
        console.error("Error waiting for ShopifyChat:", error);
      });
    }).catch(error => {
      console.error("Error waiting for inbox-online-store-chat:", error);
    });
  }
});


/*
document.addEventListener("DOMContentLoaded", function() {
  let mitStoreLanguage = document.querySelector('html').getAttribute('lang');
  
  if (mitStoreLanguage === 'en') {
    
    function waitForElm(selector) {
      return new Promise(resolve => {
          if (document.querySelector(selector)) {
              return resolve(document.querySelector(selector));
          }
  
          const observer = new MutationObserver(mutations => {
              if (document.querySelector(selector)) {
                  resolve(document.querySelector(selector));
                  observer.disconnect();
              }
          });
  
          observer.observe(document.body, {
              childList: true,
              subtree: true
          });
      });
    }

    waitForElm('inbox-online-store-chat').then((elm) => {

      console.log("ShopifyChat", document.getElementById('ShopifyChat'))
      
      const host = document.getElementById('ShopifyChat');
      const shadowRoot = host.shadowRoot;

      const shopifyChat = document.getElementById('ShopifyChat');
    
      function chatTranslate() {
          const storeInfo = shadowRoot.querySelector('.store-info p');
          
          const buttonElements = shadowRoot.querySelectorAll('.instant-answers-list__prompt');          
          const firstButtonElement = buttonElements[0];
          const secondButtonElement = buttonElements[1];
          const thirdButtonElement = buttonElements[2];
          const forthButtonElement = buttonElements[3];
          const fifthButtonElement = buttonElements[4];

          
              // Beispiel: Ändern des Textinhalts des <p>-Elements
              if (storeInfo) {
                storeInfo.textContent = 'Hello! 👋 We are here to help you! Customer service: MON - FRI, 8 AM - 12 PM and 1 PM - 4 PM. We usually respond within 5-10 minutes.';
              } 

              if (firstButtonElement) {
                firstButtonElement.textContent = 'Shipping status of my order?';
              }
          
              if (secondButtonElement) {
                secondButtonElement.textContent = "How do I return from Austria?";
              }
          
              if (thirdButtonElement) {
                thirdButtonElement.textContent = "How do I return from Germany?";
              }

              if (forthButtonElement) {
                forthButtonElement.textContent = "Which countries do we ship?";
              }      

              if (fifthButtonElement) {
                fifthButtonElement.textContent = "In which unit are the sizes indicated?";
              }  

              // Answers
                  setInterval(function(){
                    shadowRoot.querySelectorAll('.message-bubble-outgoing span').forEach(function(element) {
                      if (element.textContent.includes("Sendungsverlauf meiner Bestellung")) {
                        element.outerHTML = "<span>Shipping status of my order?</span>";
                      }
                      if (element.textContent.includes("Österreich?")) {
                        element.outerHTML = "<span>How do I return from Austria?</span>";
                      }      
                      if (element.textContent.includes("Deutschland?")) {
                        element.outerHTML = "<span>How do I return from Germany?</span>";
                      }      
                      if (element.textContent.includes("In welche Länder")) {
                        element.outerHTML = "<span>Which countries do we ship?</span>";
                      }      
                      if (element.textContent.includes("Größen werden")) {
                        element.outerHTML = "<span>In which unit are the sizes indicated?</span>";
                      }                      
                    });
  
                    shadowRoot.querySelectorAll('.message-bubble-incoming span').forEach(function(element) {
                      if (element.textContent.includes("Hallo, bitte geben Sie uns Ihre Bestellnummer, ")) {
                        element.outerHTML = "<span>Hello, please provide your order number starting with #XXXXX-D1948. We'll help you check your package status.</span>";
                      }
                      if (element.textContent.includes("Österreich ")) {
                        element.outerHTML = "<span>Orders from Austria include a prepaid return label. Please register your return in your customer account. Returns are free of charge. Your Dantendorfer Team 💙</span>";
                      }      
                      if (element.textContent.includes("LogoIX")) {
                        element.outerHTML = "<span>To start your return, log into your customer account. You received the LogoIX return label in your shipping confirmation email. If you can't find the email, just give us your order number (#XXXXX-D1948), and we'll send you another copy by email. Your Dantendorfer Team. 💙</span>";
                      }    
                     if (element.textContent.includes("4-6 Werktage")) {
                        element.outerHTML = "<span>We ship worldwide. Once we confirm availability of your items, you'll receive your package in 4-6 business days. Customers are responsible for return shipping costs. Your Dantendorfer Team 💙</span>";
                      }      
                      if (element.textContent.includes("internationalen Hersteller")) {
                        element.outerHTML = "<span>Hello, we have converted all our international manufacturers' sizes into German clothing sizes. If you're unsure which size corresponds to your country, please check the size chart provided with each product. Best regards, Your Dantendorfer Team</span>";
                      }    
                      if (element.textContent.includes("+43 662 845735 180")) {
                        element.outerHTML = "<span>Thank you for your message! We will get back to you as soon as possible!<br><br>For urgent matters, you can also reach us by phone during our business hours at +43 662 845735 180.<br><br>Best regards from Salzburg, your Dantendorfer team. 💙</span>";
                      }
                      if (element.textContent.includes("nicht online")) {
                        element.outerHTML = "<span>Hello, we are currently not online. Please provide us with any information that will make it easier for us to assist you.<br><br>We will get back to you as soon as possible.<br><br>Customer service hours: Monday - Friday, 8am - 12pm | 1pm - 4pm.<br><br>Best regards from Salzburg, your Dantendorfer team. 💙</span>";
                      }
                    });    
                 
                    
                  },100);      
              };

      // Run function when clicking on chat

       setInterval(function(){
          chatTranslate();
       },500);     

        // Set interval so that chat is translated within the first seconds
        let chatMaxIterations = 3;
        let chatCurrentIteration = 0;
        
        // Start the interval
        let chatInterval = setInterval(function() {
          chatTranslate();
            chatCurrentIteration++;

            if (chatCurrentIteration >= chatMaxIterations) {
                clearInterval(chatInterval);
            }
        }, 500);
    }); // End wait for Chat
  }
}); // End of domloaded
*/

/* NEW */

// Function to check if an item is a voucher based on product type or tags
/*function isVoucherProduct(item) {
    return item.product_title.includes("Geschenk");
}*/
function isVoucherProduct(item) {
    const lowercaseTitle = item.product_title.toLowerCase();
    return lowercaseTitle.includes("geschenk") || lowercaseTitle.includes("gift voucher");
}

// Function to check cart and handle voucher validation
async function validateVouchersInCart() {
    try {
        // Fetch current cart state
        const response = await fetch('/cart.js');
        const cart = await response.json();
        const items = cart.items;
        const voucherItems = items.filter(item => isVoucherProduct(item));
        const nonVoucherItems = items.filter(item => !isVoucherProduct(item));

      if(voucherItems.length == 0) {
        if(document.querySelector('.cart-message')) document.querySelector('.cart-message').remove();
      }

        // If we have both voucher and non-voucher items
        if (voucherItems.length > 0 && nonVoucherItems.length > 0) {
            // Remove voucher items
            const updates = {};
            // Set quantity to 0 for all voucher items
            voucherItems.forEach(item => {
                updates[item.variant_id] = 0;
            });

            // Update cart
            await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ updates: updates })
            });

            // Show error message and store it in sessionStorage      
            const message = window.location.host.includes(".dantendorfer.com") ? 'Giftcards are sold separately.' : 'Geschenkkarte entfernt - Bitte legen Sie Gutscheine einzeln in den Warenkorb.'
            showErrorMessage(message);
            sessionStorage.setItem('cartMessage', message);
            
            // Refresh the cart UI
            refreshCart();
        }
    } catch (error) {
        console.error('Error validating cart:', error);
        showErrorMessage('An error occurred while updating your cart. Please try again.');
    }
}

// Function to show error message
function showErrorMessage(message) {
    let messageContainer = document.querySelector('.cart-message');
    
    if (!messageContainer) {
        messageContainer = createMessageContainer();
    }
    
    messageContainer.innerHTML = `<div style=" background-color: var(--color-background-meta); margin-bottom: 2rem; padding: 1rem 2rem; font-weight: 500; text-transform: uppercase;" role="alert">${message}</div>`;
    messageContainer.style.display = 'block'; // Ensure visibility
}

// Function to create message container if it doesn't exist
function createMessageContainer() {
    const container = document.createElement('div');
    container.className = 'cart-message';
    // Add the container before the cart items
    const cartItems = document.querySelector('.cart-template__items');
    if (cartItems && cartItems.parentNode) {
        cartItems.parentNode.insertBefore(container, cartItems);
    }
    return container;
}

// Function to refresh cart UI and hide voucher products
async function refreshCart() {
    try {
        // Store the current message if it exists
        const currentMessage = document.querySelector('.cart-message')?.innerHTML;

        // Find the section div dynamically
        const mainContent = document.getElementById('main-content');
        const sectionDiv = mainContent.querySelector("div");

        // Extract section ID from the class name
        const sectionClassName = sectionDiv.id;

        // Remove 'shopify-section-' prefix to get the section ID
        const sectionId = sectionClassName.replace('shopify-section-', '');
        
        // Fetch the updated cart section
        //const response = await fetch('?section_id=template--23910510985558__main');
        const response = await fetch(`?section_id=${sectionId}`);
        const html = await response.text();
        
        // Create a temporary container to parse the HTML
        const tempContainer = document.createElement('div');
        tempContainer.innerHTML = html;
        
        // Find all cart items in the new HTML
        const cartItems = tempContainer.querySelectorAll('.cart-item');
        
        // Hide voucher products
        cartItems.forEach(item => {
            const productTitle = item.querySelector('.cart-item__title')?.textContent || '';
            if (isVoucherProduct({ product_title: productTitle })) {
                item.style.display = 'none';
            }
        });

        // Update the cart section with the modified HTML
        // const cartSection = document.querySelector("#shopify-section-template--23910510985558__main"); // Hide for now
        const cartSection = document.querySelector("#main-content > div");
        cartSection.innerHTML = tempContainer.innerHTML;

        // Restore or create message container after cart refresh
        const storedMessage = sessionStorage.getItem('cartMessage');
        if (storedMessage || currentMessage) {
            showErrorMessage(storedMessage || currentMessage);
        }
        
        // Update cart count and totals if needed
        updateCartCountsAndTotals();
    } catch (error) {
        console.error('Error refreshing cart:', error);
    }
}

// Function to update cart counts and totals
async function updateCartCountsAndTotals() {
    try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        const nonVoucherItems = cart.items.filter(item => !isVoucherProduct(item));
        
        // Update item count
        const itemCount = nonVoucherItems.reduce((acc, item) => acc + item.quantity, 0);
        document.querySelectorAll('.cart-count').forEach(el => {
            el.textContent = itemCount;
        });
        
        // Update total price (excluding voucher items)
        const totalPrice = nonVoucherItems.reduce((acc, item) => acc + (item.price * item.quantity), 0);
        document.querySelectorAll('.cart-total').forEach(el => {
            el.textContent = formatMoney(totalPrice);
        });
    } catch (error) {
        console.error('Error updating cart counts and totals:', error);
    }
}

// Helper function to format money (adjust according to your currency format)
function formatMoney(cents) {
    return (cents / 100).toLocaleString('de-DE', {
        style: 'currency',
        currency: 'EUR'
    });
}

// Add event listeners
document.addEventListener('DOMContentLoaded', () => {
    // Initial cart validation
    validateVouchersInCart();
    
    // Check for stored message on page load
    const storedMessage = sessionStorage.getItem('cartMessage');
    if (storedMessage) {
        showErrorMessage(storedMessage);
    }
    
    // Listen for cart updates
    document.addEventListener('cart:updated', validateVouchersInCart);
    
    // If using ajax add-to-cart
    document.addEventListener('product:added', validateVouchersInCart);
});



// New filter buttons in the search page
document.addEventListener('DOMContentLoaded', function() {
  if (window.location.href.includes('/a/search')) {
    // Immediately create and inject a style to hide the filter pane
    const hideFilterPaneStyle = document.createElement('style');
    hideFilterPaneStyle.id = 'hide-filter-pane-style';
    hideFilterPaneStyle.textContent = `
      .cloud-search-filters-pane,
      .cloud-search-filters-pane-backdrop {
        display: none !important;
      }
    `;
    document.head.appendChild(hideFilterPaneStyle);
    
    // Wait for the page to fully load
    setTimeout(function() {
      // Get the filter root element
      const filterRoot = document.querySelector('#cloud_search_filters_root');
      
      if (!filterRoot) {
        console.error('Filter root element not found');
        // Remove the style if we can't continue
        document.head.removeChild(hideFilterPaneStyle);
        return;
      }
      
      // Create the main div container
      const mainDiv = document.createElement('div');
      mainDiv.classList.add("mit-div-btns-filter")
      mainDiv.style.display = 'grid';
      mainDiv.style.gridTemplateColumns = '1fr auto 1fr';
      mainDiv.style.alignItems = 'center';
      mainDiv.style.padding = '10px 0';
      mainDiv.style.width = '100%';
      
      // Detect language - check if page is in German
      const isGerman = document.documentElement.lang === 'de' || 
                      window.location.href.includes('/de/') || 
                      document.querySelector('html[lang="de"]') !== null;
      
      // First, let's check if the gender filters are available
      const filterLink = document.querySelector('.cloud-search-page-controls__filters-link');
      if (!filterLink) {
        console.error('Filter link not found');
        // Remove the style if we can't continue
        document.head.removeChild(hideFilterPaneStyle);
        return;
      }
      
      // Create a div for the buttons (center column)
      const buttonContainer = document.createElement('div');
      buttonContainer.style.display = 'flex';
      buttonContainer.style.justifyContent = 'center';
      buttonContainer.style.gap = '10px';
      
      // Create a div for the filter link (right column)
      const filterLinkContainer = document.createElement('div');
      filterLinkContainer.style.display = 'flex';
      filterLinkContainer.style.justifyContent = 'flex-end';
      filterLinkContainer.style.paddingRight = '15px';
      
      // Add the original filter root to the right column
      filterLinkContainer.appendChild(filterRoot);
      
      // Append all parts to the main div
      mainDiv.appendChild(document.createElement('div')); // Empty first column
      mainDiv.appendChild(buttonContainer); // Center column with buttons
      mainDiv.appendChild(filterLinkContainer); // Right column with filter link
      
      // Find the parent element and insert the div at the beginning
      const searchTemplate = document.querySelector('.search-template__partial');
      if (searchTemplate) {
        searchTemplate.insertBefore(mainDiv, searchTemplate.firstChild);
      } else {
        console.warn('Search template element not found');
        // Remove the style if we can't continue
        document.head.removeChild(hideFilterPaneStyle);
        return;
      }
      
      // Function to select a filter and apply it
      function applyFilter(filterValue) {
        // Add the hide style before opening the filter pane
        document.head.appendChild(hideFilterPaneStyle);
        
        // First, find and click the filter link to open the filters panel
        const filterLink = document.querySelector('.cloud-search-page-controls__filters-link');
        if (filterLink) {
          filterLink.click();
          
          // Wait for filters to load in the DOM
          const checkFiltersInterval = setInterval(() => {
            const filterElement = document.querySelector(`label[data-filter-value="${filterValue}"]`);
            
            if (filterElement) {
              clearInterval(checkFiltersInterval);
              
              // Reset all filters first
              document.querySelectorAll('.cloud-search-filter-value--selected').forEach(element => {
                element.classList.remove('cloud-search-filter-value--selected');
              });
              
              document.querySelectorAll('.cloud-search-filter--active').forEach(element => {
                element.classList.remove('cloud-search-filter--active');
              });
              
              // Add selected class to the filter value
              filterElement.classList.add('cloud-search-filter-value--selected');
              
              // Find the parent filter group and add active class
              const filterGroup = filterElement.closest('.cloud-search-filter');
              if (filterGroup) {
                filterGroup.classList.add('cloud-search-filter--active');
              }
              
              // Check the checkbox
              const checkbox = filterElement.querySelector('input[type="checkbox"]');
              if (checkbox) {
                checkbox.checked = true;
                
                // Create and dispatch change event
                const event = new Event('change', { bubbles: true });
                checkbox.dispatchEvent(event);
              }
              
              // Wait for the apply button to be created
              setTimeout(() => {
                // Find and click the apply button
                const applyButton = document.querySelector('.cloud-search-filters-apply');
                if (applyButton) {
                  applyButton.click();
                  
                  // Remove the hide style after filtering is complete
                  if (hideFilterPaneStyle.parentNode) {
                    document.head.removeChild(hideFilterPaneStyle);
                  }
                } else {
                  console.error('Apply button not found');
                  // Remove the hide style if we can't continue
                  if (hideFilterPaneStyle.parentNode) {
                    document.head.removeChild(hideFilterPaneStyle);
                  }
                }
              }, 500); // Wait for the apply button to appear
            }
          }, 100); // Check every 100ms for the filter element
          
          // Set a timeout to clear the interval if filters don't load
          setTimeout(() => {
            clearInterval(checkFiltersInterval);
            console.error(`Filter for ${filterValue} not found after timeout`);
            // Remove the hide style if we time out
            if (hideFilterPaneStyle.parentNode) {
              document.head.removeChild(hideFilterPaneStyle);
            }
          }, 5000); // 5 second timeout
        } else {
          console.error('Filter link not found');
          // Remove the hide style if we can't continue
          if (hideFilterPaneStyle.parentNode) {
            document.head.removeChild(hideFilterPaneStyle);
          }
        }
      }
      
      // Click the filter link to check for gender filters
      filterLink.click();
      
      // Set a timeout to check if filters are loaded and check for gender filters
      setTimeout(() => {
        const womenFilter = document.querySelector('label[data-filter-value="Damen"]');
        const menFilter = document.querySelector('label[data-filter-value="Herren"]');
        
        // Close the filter panel using the close button
        const closeButton = document.querySelector('.cloud-search-filters-pane__close');
        if (closeButton) {
          closeButton.click();
        } else {
          // Fallback: click the filter link again to toggle
          filterLink.click();
        }
        
        // Now we can safely remove the hide style
        if (hideFilterPaneStyle.parentNode) {
          document.head.removeChild(hideFilterPaneStyle);
        }
        
        // Only add buttons if at least one gender filter exists
        if (womenFilter || menFilter) {
          // Create the Women button if the filter exists
          if (womenFilter) {
            const womenButton = document.createElement('button');
            womenButton.textContent = isGerman ? 'Damen' : 'Women';
            womenButton.classList.add("mit-custom-search-filter-btn")
            
            // Add click event listener to the button
            womenButton.addEventListener('click', function() {
              applyFilter("Damen");
            });
            
            buttonContainer.appendChild(womenButton);
          }
          
          // Create the Men button if the filter exists
          if (menFilter) {
            const menButton = document.createElement('button');
            menButton.textContent = isGerman ? 'Herren' : 'Men';
            menButton.classList.add("mit-custom-search-filter-btn")
            
            // Add click event listener to the button
            menButton.addEventListener('click', function() {
              applyFilter("Herren");
            });
            
            buttonContainer.appendChild(menButton);
          }

          document.querySelector(".template-search #cloud_search_filters_root").style.opacity = "1";
        } else {
          // If no gender filters exist, hide the button container
          buttonContainer.style.display = 'none';
        }
      }, 1000); // Wait for filters to load
      
    }, 1000); // Added delay to ensure all elements are loaded
  }
});

// Menu Mobile Sale Red
document.addEventListener('DOMContentLoaded', function() {
    // Function to check if we're on mobile
    function isMobile() {
        return window.innerWidth <= 768;
    }
    
    // Function to make ONLY the main sale menu item red (not submenus)
    function makeSaleItemsRed() {
        if (isMobile()) {
            // Find all menu links that are top-level (not in submenus)
            const menuSelectors = [
                'nav > ul > li > a',
                '.menu > li > a',
                '.navigation > li > a',
                '.mobile-menu > li > a',
                '.mobile-nav > li > a',
                'header nav > ul > li > a',
                '[class*="menu"] > li > a',
                '[class*="nav"] > ul > li > a',
                '.site-nav > li > a',
                '.main-menu > li > a',
                '.mobile-menu-item > a',
                '.nav-item > a',
                '.menu-item > a',
                'nav > a',
                '.mobile-menu > a',
                '.mobile-nav > a'
            ];
            
            menuSelectors.forEach(selector => {
                try {
                    const links = document.querySelectorAll(selector);
                    links.forEach(link => {
                        // Check if this is a top-level menu item (not in a submenu)
                        const isTopLevel = !link.closest('.submenu, .sub-menu, .dropdown-menu, .child-menu, [class*="submenu"], [class*="dropdown"]');
                        
                        if (isTopLevel) {
                            // Look for a span inside the link
                            const span = link.querySelector('span');
                            if (span) {
                                const spanText = span.textContent.toLowerCase();
                                
                                // Check if the span contains "sale"
                                if (spanText.includes('sale')) {
                                    // Make the entire link red
                                    link.style.color = 'red';
                                    link.style.setProperty('color', 'red', 'important');
                                    
                                    // Also make the span red to ensure it inherits the color
                                    span.style.color = 'red';
                                    span.style.setProperty('color', 'red', 'important');
                                }
                            }
                        }
                    });
                } catch (e) {
                    // Skip if selector doesn't match
                }
            });
        }
    }
    
    // Run on page load
    makeSaleItemsRed();
    
    // Run on window resize
    window.addEventListener('resize', makeSaleItemsRed);
    
    // For SPAs or dynamically loaded content
    const observer = new MutationObserver(makeSaleItemsRed);
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});